export enum InvoiceValidationErrorType {
NoIncomeClassificationProvided,
IncomeClassificationAmountDoesNotMatch,
NoExpensesClassificationProvided,
ExpensesClassificationAmountDoesNotMatch,
NoExpensesVATClassificationProvided,
ExpensesVATClassificationAmountDoesNotMatch,
AccountingClassificationAmountDoesNotMatch,
NoPaymentMethod,
PaymentsTotalAmountDoesNotMatch,
NoCurrency,
NoIssuer,
NoCounterpart,
NoSpendingRequestWarning,
NoSpendingRequestError,
NoSeries,
NoInvoiceType,
NoInvoiceLines,
}
